import { combineReducers } from 'redux';
import pinnedListings from './pinned_listings';
import searchResults from './search_results';
import module from './module';

const rootReducer = combineReducers({ pinnedListings, searchResults, module });

export default rootReducer;
